import { core } from 'core/api/services';
import { endpoints,single } from 'libs/api/typed';
import { DEFAULT_METHODS } from 'libs/api';


import { WLProductT } from './model';

type Params = {
  payload: {
    domain: string;
  };
  success: WLProductT & { email: string };
  error: never;
};

export type GroupSMSSettingsRequestPayload = {
  uuid: string;
  sms_number: string;
  sid: string;
  auth_token?: string;
};

type CustomMethods = {
  updateSmsParameters: {
    payload: GroupSMSSettingsRequestPayload;
    success: true;
    error: never;
  };
};

// Read by the sign-in screens before anyone is signed in, so it is an application route, not a /v1 one.
// The operation names the contract entry the response is decoded with until the generated codecs are retired.
export const getProductDetails = single<Params>(core.get('/core/products'));

export const wlProductGroupApi = endpoints<Pick<DEFAULT_METHODS<WLProductT> & CustomMethods, 'create' | 'update' | 'updateSmsParameters'>>({
  create: core.post('/core/white_label_products'),
  update: core.post('/core/white_label_products/{uuid}'),
  updateSmsParameters: core.post('/core/white_label_products/{uuid}'),
});
